"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bluebase/core");
/**
 * # 🖥 Observes changes in Screen Orientation
 */
exports.OrientationObserver = core_1.getComponent('OrientationObserver');
